import { Button, Icon } from '@mgmresorts/mgm-ui';
import React, { ReactElement } from 'react';

import { StyledContent, StyledHeading, StyledIconContainer, StyledInfo } from './Confirmation.styles';
import { Container } from './Container';
import { Logo } from './Logo';
import { PageLayout } from './PageLayout';

interface ConfirmationProps {
  title: string;
  description: string | { __html: string } | ReactElement;
  redirectCTA?: {
    label: string;
    action: () => Promise<void> | void;
  };
  testId?: string;
  icon?: React.ReactNode;
  noIcon?: boolean;
}

export const Confirmation = ({ title, description, redirectCTA, icon, noIcon, testId }: ConfirmationProps) => {
  return (
    <StyledContent>
      <PageLayout title={title} testId={testId}>
        <Container height='auto'>
          <Logo />

          {!noIcon &&
            (icon || (
              <StyledIconContainer>
                <Icon name='checkmark-circle' size='large' variant='filled' />
              </StyledIconContainer>
            ))}
          <StyledHeading
            variant='body-medium-l'
            as='h1'
            className='identity__confirmation-title'
            data-testid='confirmation-title'
          >
            {title}
          </StyledHeading>

          {typeof description === 'string' ? (
            <StyledInfo
              variant='body-regular-l'
              className='identity__verification-description'
              testId='confirmation-description'
            >
              {description}
            </StyledInfo>
          ) : typeof description === 'object' && description !== null && '__html' in description ? (
            <StyledInfo
              variant='body-regular-l'
              className='identity__verification-description'
              testId='confirmation-description'
              dangerouslySetInnerHTML={description as { __html: string }}
            />
          ) : (
            <StyledInfo
              variant='body-regular-l'
              className='identity__verification-description'
              testId='confirmation-description'
            >
              {description as ReactElement}
            </StyledInfo>
          )}

          {redirectCTA ? (
            <Button
              label={redirectCTA.label}
              variant='primary'
              size='large'
              fullWidth
              testId='confirmation-cta'
              onClick={async () => {
                await redirectCTA.action();
              }}
              onKeyDown={async e => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  await redirectCTA.action();
                }
              }}
              className='identity__form-submit'
              type='submit'
            />
          ) : null}
        </Container>
      </PageLayout>
    </StyledContent>
  );
};

Confirmation.displayName = 'Confirmation';
